
module.exports = require('./StyleGuideComponent.jsx');



/** WEBPACK FOOTER **
 ** ./app/components/StyleGuideHandler/index.js
 **/